export default "__VITE_ASSET__CvXV0aCZ__"